import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { useLanguage } from "../lib/language";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function CheckoutResult({ kind }) {
    const { t } = useLanguage();
    const [params] = useSearchParams();
    const [status, setStatus] = useState("checking");
    const session_id = params.get("session_id");

    useEffect(() => {
        if (kind !== "success" || !session_id) { setStatus(kind); return; }
        let attempts = 0;
        const poll = async () => {
            attempts++;
            try {
                const { data } = await api.get(`/checkout/status/${session_id}`);
                if (data.payment_status === "paid") setStatus("paid");
                else if (data.status === "expired") setStatus("expired");
                else if (attempts < 6) setTimeout(poll, 2000);
                else setStatus("timeout");
            } catch { setStatus("error"); }
        };
        poll();
    }, [session_id, kind]);

    const isSuccess = status === "paid";
    const isLoading = status === "checking";

    return (
        <div className="max-w-2xl mx-auto px-6 py-24 text-center fade-in">
            {isLoading && <Loader2 className="w-12 h-12 text-[var(--tb-gold)] animate-spin mx-auto mb-6" />}
            {isSuccess && <CheckCircle2 className="w-16 h-16 text-[#4CAF50] mx-auto mb-6" />}
            {!isLoading && !isSuccess && <XCircle className="w-16 h-16 text-[#F44336] mx-auto mb-6" />}
            <h1 className="font-display text-4xl mb-4">
                {isLoading ? t("Verificando pago...", "Verifying payment...") : isSuccess ? t("¡Pago Exitoso!", "Payment Successful!") : t("Pago no completado", "Payment not completed")}
            </h1>
            <p className="text-[var(--tb-text-2)] mb-8">
                {isSuccess ? t("Gracias por tu compra. Te enviaremos detalles a tu correo.", "Thanks for your purchase. We'll email you the details.") : t("Si fue un error, intenta de nuevo desde tu carrito.", "If it was an error, try again from your cart.")}
            </p>
            <Link to="/perfil?tab=ordenes" className="tb-btn-primary inline-block" data-testid="result-orders-link">{t("Ver mis pedidos", "View my orders")}</Link>
        </div>
    );
}
